// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bgsr","left":"styles_left__1UGid"};